import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { Dupe } from 'src/app/shared/models/dupe.model';
import { DupesService } from 'src/app/shared/services/dupes.service';
import { FormatService } from 'src/app/shared/services/format.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { AuthService } from '../../account/auth.service';
import { User } from '../../account/user.model';

@Component({
    selector: 'app-dupes',
    templateUrl: './dupes.component.html',
    styleUrls: ['./dupes.component.scss'],
    standalone: false
})
export class DupesComponent implements OnInit {
  @Output() dupeLoadingComplete = new EventEmitter();
  @Output() dupesComplete = new EventEmitter();
  userId: string = null;
  isLoading: boolean = true;
  dupes: Dupe[];
  User: User = null;
  constructor(
    private _DupesService: DupesService,
    private authService: AuthService,
    public _formatService: FormatService,
    public globalService: GlobalService
  ) { }

  async ngOnInit() {

    this.User = await this.authService.autoLogin(1);
    if (this.User != null) {
      this.userId = this.User.id;
      this.dupes = await this._DupesService.getDupes(this.userId);
      this.dupes.map((a) => {
        a['answer'] = 0;
        a['selection'] = 0;
        a['resolved'] = false;
      });
      this.isLoading = false;
      this.dupeLoadingComplete.emit();
      if (this.dupes.length == 0) this.dupesComplete.emit();
    } else this.dupesComplete.emit();
  }

  MarkAsDifferent(index: number) {
    this._DupesService.markAsDifferent(
      this.dupes[index]['member1'].id,
      this.dupes[index]['member2'].id
    );
    this.dupes[index]['resolved'] = true;
    if (this.dupes.findIndex((a) => a['resolved'] == false) < 0)
      this.dupesComplete.emit();
  }

  Merge(index: number, selection: number) {
    if (selection == 1)
      this._DupesService.resolveDupe(
        this.dupes[index]['member2'].id,
        this.dupes[index]['member1'].id
      );
    else if (selection == 2)
      this._DupesService.resolveDupe(
        this.dupes[index]['member1'].id,
        this.dupes[index]['member2'].id
      );
    this.dupes[index]['resolved'] = true;
    if (this.dupes.findIndex((a) => a['resolved'] == false) < 0)
      this.dupesComplete.emit();
  }
}
